<template>
    <div class="p-icon-user-rank">
      <div class="p-icon-user-rank__inner" :style="setStyleObj">
        <slot>
          <img src="/general/assets/img/common/icon/icon-dummy.png" alt />
        </slot>
      </div>
    </div>
  </template>

<script lang="ts">
import globals from "@/general/store/modules/globals";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    size: { type: Number, default: 48 },
    spSize: { type: [Number, Boolean], default: false }
  }
})
export default class IconUserRank extends Vue {
  size!: number;
  spSize!: number;

  isSp = globals.isSpScreenWidth;

  get setStyleObj() {
    const size = this.size;
    const spSize = this.spSize;
    const isSp = this.isSp;
    const spImageSize = spSize || size;
    const resultImageSize = isSp ? spImageSize : size;
    const calcRem = (value: any) => `${value / 16}rem`;

    return {
      width: calcRem(resultImageSize),
      minWidth: calcRem(resultImageSize),
      maxHeight: "30px",
    };
  }

  get commonUserInfo(){
    return commons?.userInfo
  }
}
</script>

<style lang="scss" scoped>
.p-icon-user-rank {
  position: relative;
  width: 120px;
  height: 30px;
  overflow: hidden;

  &__inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    @include large-pc {
      justify-content: center
    }
    @include large-sp {
      margin: 0;
    }
  }

  img,
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}
</style>

